export const countries = [
  {
    countryNameLocal: 'Andorra',
    countrySynonymsLocal: '',
    countryCode: 'AD',
    currencyCode: 'EUR',
    officialLanguageCode: 'ca'
  },
  {
    countryNameLocal:
      'د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان',
    countrySynonymsLocal: '',
    countryCode: 'AF',
    currencyCode: 'AFN',
    officialLanguageCode: 'fa'
  },
  {
    countryNameLocal: 'Antigua and Barbuda',
    countrySynonymsLocal: '',
    countryCode: 'AG',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Anguilla',
    countrySynonymsLocal: '',
    countryCode: 'AI',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Shqipëria',
    countrySynonymsLocal: '',
    countryCode: 'AL',
    currencyCode: 'ALL',
    officialLanguageCode: 'sq'
  },
  {
    countryNameLocal: 'Հայաստան',
    countrySynonymsLocal: '',
    countryCode: 'AM',
    currencyCode: 'AMD',
    officialLanguageCode: 'hy'
  },
  {
    countryNameLocal: 'Angola',
    countrySynonymsLocal: '',
    countryCode: 'AO',
    currencyCode: 'AOA',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Antarctica, Antártico, Antarctique, Антарктике',
    countrySynonymsLocal: '',
    countryCode: 'AQ',
    currencyCode: '',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Argentina',
    countrySynonymsLocal: '',
    countryCode: 'AR',
    currencyCode: 'ARS',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'American Samoa',
    countrySynonymsLocal: '',
    countryCode: 'AS',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Österreich',
    countrySynonymsLocal: '',
    countryCode: 'AT',
    currencyCode: 'EUR',
    officialLanguageCode: 'de'
  },
  {
    countryNameLocal: 'Australia',
    countrySynonymsLocal: '',
    countryCode: 'AU',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Aruba',
    countrySynonymsLocal: '',
    countryCode: 'AW',
    currencyCode: 'AWG',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Åland',
    countrySynonymsLocal: '',
    countryCode: 'AX',
    currencyCode: 'EUR',
    officialLanguageCode: 'sv'
  },
  {
    countryNameLocal: 'Azərbaycan',
    countrySynonymsLocal: '',
    countryCode: 'AZ',
    currencyCode: 'AZN',
    officialLanguageCode: 'az'
  },
  {
    countryNameLocal: 'Bosna i Hercegovina',
    countrySynonymsLocal: '',
    countryCode: 'BA',
    currencyCode: 'BAM',
    officialLanguageCode: 'bs'
  },
  {
    countryNameLocal: 'Barbados',
    countrySynonymsLocal: '',
    countryCode: 'BB',
    currencyCode: 'BBD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'গণপ্রজাতন্ত্রী বাংলাদেশ',
    countrySynonymsLocal: '',
    countryCode: 'BD',
    currencyCode: 'BDT',
    officialLanguageCode: 'bn'
  },
  {
    countryNameLocal: 'België, Belgique, Belgien',
    countrySynonymsLocal: '',
    countryCode: 'BE',
    currencyCode: 'EUR',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Burkina Faso',
    countrySynonymsLocal: '',
    countryCode: 'BF',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'България',
    countrySynonymsLocal: '',
    countryCode: 'BG',
    currencyCode: 'BGN',
    officialLanguageCode: 'bg'
  },
  {
    countryNameLocal: 'البحرين',
    countrySynonymsLocal: '',
    countryCode: 'BH',
    currencyCode: 'BHD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Burundi',
    countrySynonymsLocal: '',
    countryCode: 'BI',
    currencyCode: 'BIF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Bénin',
    countrySynonymsLocal: '',
    countryCode: 'BJ',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Saint-Barthélemy',
    countrySynonymsLocal: '',
    countryCode: 'BL',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Bermuda',
    countrySynonymsLocal: '',
    countryCode: 'BM',
    currencyCode: 'BMD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Brunei Darussalam',
    countrySynonymsLocal: '',
    countryCode: 'BN',
    currencyCode: 'BND',
    officialLanguageCode: 'ms'
  },
  {
    countryNameLocal: 'Bolivia, Bulibiya, Volívia, Wuliwya',
    countrySynonymsLocal: '',
    countryCode: 'BO',
    currencyCode: 'BOP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Caribisch Nederland',
    countrySynonymsLocal: '',
    countryCode: 'BQ',
    currencyCode: 'USD',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Brasil',
    countrySynonymsLocal: '',
    countryCode: 'BR',
    currencyCode: 'BRL',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'འབྲུག་ཡུལ',
    countrySynonymsLocal: '',
    countryCode: 'BT',
    currencyCode: 'BTN',
    officialLanguageCode: 'dz'
  },
  {
    countryNameLocal: 'Bouvetøya',
    countrySynonymsLocal: '',
    countryCode: 'BV',
    currencyCode: 'NOK',
    officialLanguageCode: 'no'
  },
  {
    countryNameLocal: 'Botswana',
    countrySynonymsLocal: '',
    countryCode: 'BW',
    currencyCode: 'BWP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Беларусь',
    countrySynonymsLocal: '',
    countryCode: 'BY',
    currencyCode: 'BYR',
    officialLanguageCode: 'be'
  },
  {
    countryNameLocal: 'Belize',
    countrySynonymsLocal: '',
    countryCode: 'BZ',
    currencyCode: 'BZD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Canada',
    countrySynonymsLocal: '',
    countryCode: 'CA',
    currencyCode: 'CAD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Schweiz, Suisse, Svizzera, Svizra',
    countrySynonymsLocal: '',
    countryCode: 'CH',
    currencyCode: 'CHE',
    officialLanguageCode: 'de'
  },
  {
    countryNameLocal: "Côte d'Ivoire",
    countrySynonymsLocal: '',
    countryCode: 'CI',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Chile',
    countrySynonymsLocal: '',
    countryCode: 'CL',
    currencyCode: 'CLP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Cameroun, Cameroon',
    countrySynonymsLocal: '',
    countryCode: 'CM',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: '中国',
    countrySynonymsLocal: '',
    countryCode: 'CN',
    currencyCode: 'CNY',
    officialLanguageCode: 'zh-hans'
  },
  {
    countryNameLocal: 'Colombia',
    countrySynonymsLocal: '',
    countryCode: 'CO',
    currencyCode: 'COP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Costa Rica',
    countrySynonymsLocal: '',
    countryCode: 'CR',
    currencyCode: 'CRC',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Cuba',
    countrySynonymsLocal: '',
    countryCode: 'CU',
    currencyCode: 'CUC',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Cabo Verde',
    countrySynonymsLocal: '',
    countryCode: 'CV',
    currencyCode: 'CVE',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Curaçao',
    countrySynonymsLocal: '',
    countryCode: 'CW',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'Christmas Island',
    countrySynonymsLocal: '',
    countryCode: 'CX',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Κύπρος, Kibris',
    countrySynonymsLocal: '',
    countryCode: 'CY',
    currencyCode: 'EUR',
    officialLanguageCode: 'el'
  },
  {
    countryNameLocal: 'Deutschland',
    countrySynonymsLocal: '',
    countryCode: 'DE',
    currencyCode: 'EUR',
    officialLanguageCode: 'de'
  },
  {
    countryNameLocal: 'Djibouti, جيبوتي, Jabuuti, Gabuutih',
    countrySynonymsLocal: '',
    countryCode: 'DJ',
    currencyCode: 'DJF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Danmark',
    countrySynonymsLocal: '',
    countryCode: 'DK',
    currencyCode: 'DKK',
    officialLanguageCode: 'da'
  },
  {
    countryNameLocal: 'Dominica',
    countrySynonymsLocal: '',
    countryCode: 'DM',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'الجزائر',
    countrySynonymsLocal: '',
    countryCode: 'DZ',
    currencyCode: 'DZD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Ecuador',
    countrySynonymsLocal: '',
    countryCode: 'EC',
    currencyCode: 'USD',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Eesti',
    countrySynonymsLocal: '',
    countryCode: 'EE',
    currencyCode: 'EUR',
    officialLanguageCode: 'et'
  },
  {
    countryNameLocal: 'مصر',
    countrySynonymsLocal: '',
    countryCode: 'EG',
    currencyCode: 'EGP',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Sahara Occidental',
    countrySynonymsLocal: '',
    countryCode: 'EH',
    currencyCode: 'MAD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'ኤርትራ, إرتريا, Eritrea',
    countrySynonymsLocal: '',
    countryCode: 'ER',
    currencyCode: 'ERN',
    officialLanguageCode: 'ti'
  },
  {
    countryNameLocal: 'España',
    countrySynonymsLocal: '',
    countryCode: 'ES',
    currencyCode: 'EUR',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'ኢትዮጵያ, Itoophiyaa',
    countrySynonymsLocal: '',
    countryCode: 'ET',
    currencyCode: 'ETB',
    officialLanguageCode: 'am'
  },
  {
    countryNameLocal: 'Suomi',
    countrySynonymsLocal: '',
    countryCode: 'FI',
    currencyCode: 'EUR',
    officialLanguageCode: 'fi'
  },
  {
    countryNameLocal: 'Fiji',
    countrySynonymsLocal: '',
    countryCode: 'FJ',
    currencyCode: 'FJD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Micronesia',
    countrySynonymsLocal: '',
    countryCode: 'FM',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'France',
    countrySynonymsLocal: '',
    countryCode: 'FR',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Gabon',
    countrySynonymsLocal: '',
    countryCode: 'GA',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Grenada',
    countrySynonymsLocal: '',
    countryCode: 'GD',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'საქართველო',
    countrySynonymsLocal: '',
    countryCode: 'GE',
    currencyCode: 'GEL',
    officialLanguageCode: 'ka'
  },
  {
    countryNameLocal: 'Guyane française',
    countrySynonymsLocal: '',
    countryCode: 'GF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Guernsey',
    countrySynonymsLocal: '',
    countryCode: 'GG',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Ghana',
    countrySynonymsLocal: '',
    countryCode: 'GH',
    currencyCode: 'GHS',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Gibraltar',
    countrySynonymsLocal: '',
    countryCode: 'GI',
    currencyCode: 'GIP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Kalaallit Nunaat, Grønland',
    countrySynonymsLocal: '',
    countryCode: 'GL',
    currencyCode: 'DKK',
    officialLanguageCode: 'kl'
  },
  {
    countryNameLocal: 'Guinée',
    countrySynonymsLocal: '',
    countryCode: 'GN',
    currencyCode: 'GNF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Guadeloupe',
    countrySynonymsLocal: '',
    countryCode: 'GP',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial',
    countrySynonymsLocal: '',
    countryCode: 'GQ',
    currencyCode: 'XAF',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Ελλάδα',
    countrySynonymsLocal: '',
    countryCode: 'GR',
    currencyCode: 'EUR',
    officialLanguageCode: 'el'
  },
  {
    countryNameLocal: 'South Georgia and the South Sandwich Islands',
    countrySynonymsLocal: '',
    countryCode: 'GS',
    currencyCode: '',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Guatemala',
    countrySynonymsLocal: '',
    countryCode: 'GT',
    currencyCode: 'GTQ',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Guam, Guåhån',
    countrySynonymsLocal: '',
    countryCode: 'GU',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Guiné-Bissau',
    countrySynonymsLocal: '',
    countryCode: 'GW',
    currencyCode: 'XOF',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Guyana',
    countrySynonymsLocal: '',
    countryCode: 'GY',
    currencyCode: 'GYD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: '香港, Hong Kong',
    countrySynonymsLocal: '',
    countryCode: 'HK',
    currencyCode: 'HKD',
    officialLanguageCode: 'zh-hant'
  },
  {
    countryNameLocal: 'Honduras',
    countrySynonymsLocal: '',
    countryCode: 'HN',
    currencyCode: 'HNL',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Hrvatska',
    countrySynonymsLocal: '',
    countryCode: 'HR',
    currencyCode: 'HRK',
    officialLanguageCode: 'hr'
  },
  {
    countryNameLocal: 'Haïti, Ayiti',
    countrySynonymsLocal: '',
    countryCode: 'HT',
    currencyCode: 'HTG',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Magyarország',
    countrySynonymsLocal: '',
    countryCode: 'HU',
    currencyCode: 'HUF',
    officialLanguageCode: 'hu'
  },
  {
    countryNameLocal: 'Indonesia',
    countrySynonymsLocal: '',
    countryCode: 'ID',
    currencyCode: 'IDR',
    officialLanguageCode: 'id'
  },
  {
    countryNameLocal: 'Ireland, Éire',
    countrySynonymsLocal: '',
    countryCode: 'IE',
    currencyCode: 'EUR',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'ישראל',
    countrySynonymsLocal: '',
    countryCode: 'IL',
    currencyCode: 'ILS',
    officialLanguageCode: 'he'
  },
  {
    countryNameLocal: 'Isle of Man',
    countrySynonymsLocal: '',
    countryCode: 'IM',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'भारत, India',
    countrySynonymsLocal: '',
    countryCode: 'IN',
    currencyCode: 'INR',
    officialLanguageCode: 'hi'
  },
  {
    countryNameLocal: 'British Indian Ocean Territories',
    countrySynonymsLocal: '',
    countryCode: 'IO',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'العراق, Iraq',
    countrySynonymsLocal: '',
    countryCode: 'IQ',
    currencyCode: 'IQD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'ایران',
    countrySynonymsLocal: '',
    countryCode: 'IR',
    currencyCode: 'IRR',
    officialLanguageCode: 'fa'
  },
  {
    countryNameLocal: 'Ísland',
    countrySynonymsLocal: '',
    countryCode: 'IS',
    currencyCode: 'ISK',
    officialLanguageCode: 'is'
  },
  {
    countryNameLocal: 'Italia',
    countrySynonymsLocal: '',
    countryCode: 'IT',
    currencyCode: 'EUR',
    officialLanguageCode: 'it'
  },
  {
    countryNameLocal: 'Jersey',
    countrySynonymsLocal: '',
    countryCode: 'JE',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Jamaica',
    countrySynonymsLocal: '',
    countryCode: 'JM',
    currencyCode: 'JMD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'الأُرْدُن',
    countrySynonymsLocal: '',
    countryCode: 'JO',
    currencyCode: 'JOD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: '日本',
    countrySynonymsLocal: '',
    countryCode: 'JP',
    currencyCode: 'JPY',
    officialLanguageCode: 'ja'
  },
  {
    countryNameLocal: 'Kenya',
    countrySynonymsLocal: '',
    countryCode: 'KE',
    currencyCode: 'KES',
    officialLanguageCode: 'sw'
  },
  {
    countryNameLocal: 'Кыргызстан, Киргизия',
    countrySynonymsLocal: '',
    countryCode: 'KG',
    currencyCode: 'KGS',
    officialLanguageCode: 'ky'
  },
  {
    countryNameLocal: 'កម្ពុជា',
    countrySynonymsLocal: '',
    countryCode: 'KH',
    currencyCode: 'KHR',
    officialLanguageCode: 'km'
  },
  {
    countryNameLocal: '대한민국',
    countrySynonymsLocal: '',
    countryCode: 'KR',
    currencyCode: 'KRW',
    officialLanguageCode: 'ko'
  },
  {
    countryNameLocal: 'Kiribati',
    countrySynonymsLocal: '',
    countryCode: 'KI',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Saint Kitts and Nevis',
    countrySynonymsLocal: '',
    countryCode: 'KN',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'الكويت',
    countrySynonymsLocal: '',
    countryCode: 'KW',
    currencyCode: 'KWD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Қазақстан, Казахстан',
    countrySynonymsLocal: '',
    countryCode: 'KZ',
    currencyCode: 'KZT',
    officialLanguageCode: 'kk'
  },
  {
    countryNameLocal: 'لبنان, Liban',
    countrySynonymsLocal: '',
    countryCode: 'LB',
    currencyCode: 'LBP',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Saint Lucia',
    countrySynonymsLocal: '',
    countryCode: 'LC',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Liechtenstein',
    countrySynonymsLocal: '',
    countryCode: 'LI',
    currencyCode: 'CHF',
    officialLanguageCode: 'de'
  },
  {
    countryNameLocal: 'ශ්‍රී ලංකා, இலங்கை',
    countrySynonymsLocal: '',
    countryCode: 'LK',
    currencyCode: 'LKR',
    officialLanguageCode: 'si'
  },
  {
    countryNameLocal: 'Liberia',
    countrySynonymsLocal: '',
    countryCode: 'LR',
    currencyCode: 'LRD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Lesotho',
    countrySynonymsLocal: '',
    countryCode: 'LS',
    currencyCode: 'LSL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Lietuva',
    countrySynonymsLocal: '',
    countryCode: 'LT',
    currencyCode: 'EUR',
    officialLanguageCode: 'lt'
  },
  {
    countryNameLocal: 'Lëtzebuerg, Luxembourg, Luxemburg',
    countrySynonymsLocal: '',
    countryCode: 'LU',
    currencyCode: 'EUR',
    officialLanguageCode: 'lb'
  },
  {
    countryNameLocal: 'Latvija',
    countrySynonymsLocal: '',
    countryCode: 'LV',
    currencyCode: 'EUR',
    officialLanguageCode: 'lv'
  },
  {
    countryNameLocal: 'ليبيا',
    countrySynonymsLocal: '',
    countryCode: 'LY',
    currencyCode: 'LYD',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب',
    countrySynonymsLocal: '',
    countryCode: 'MA',
    currencyCode: 'MAD',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Monaco',
    countrySynonymsLocal: '',
    countryCode: 'MC',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Crna Gora, Црна Гора',
    countrySynonymsLocal: '',
    countryCode: 'ME',
    currencyCode: 'EUR',
    officialLanguageCode: 'srp'
  },
  {
    countryNameLocal: 'Saint-Martin',
    countrySynonymsLocal: '',
    countryCode: 'MF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Madagasikara, Madagascar',
    countrySynonymsLocal: '',
    countryCode: 'MG',
    currencyCode: 'MGA',
    officialLanguageCode: 'mg'
  },
  {
    countryNameLocal: 'Mali',
    countrySynonymsLocal: '',
    countryCode: 'ML',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'မြန်မာ',
    countrySynonymsLocal: '',
    countryCode: 'MM',
    currencyCode: 'MMK',
    officialLanguageCode: 'my'
  },
  {
    countryNameLocal: 'Монгол Улс',
    countrySynonymsLocal: '',
    countryCode: 'MN',
    currencyCode: 'MNT',
    officialLanguageCode: 'mn'
  },
  {
    countryNameLocal: '澳門, Macau',
    countrySynonymsLocal: '',
    countryCode: 'MO',
    currencyCode: 'MOP',
    officialLanguageCode: 'zh-hant'
  },
  {
    countryNameLocal: 'Martinique',
    countrySynonymsLocal: '',
    countryCode: 'MQ',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'موريتانيا, Mauritanie',
    countrySynonymsLocal: '',
    countryCode: 'MR',
    currencyCode: 'MRU',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Montserrat',
    countrySynonymsLocal: '',
    countryCode: 'MS',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Malta',
    countrySynonymsLocal: '',
    countryCode: 'MT',
    currencyCode: 'EUR',
    officialLanguageCode: 'mt'
  },
  {
    countryNameLocal: 'Maurice, Mauritius',
    countrySynonymsLocal: '',
    countryCode: 'MU',
    currencyCode: 'MUR',
    officialLanguageCode: 'mfe'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'MV',
    currencyCode: 'MVR',
    officialLanguageCode: 'dv'
  },
  {
    countryNameLocal: 'Malawi',
    countrySynonymsLocal: '',
    countryCode: 'MW',
    currencyCode: 'MWK',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'México',
    countrySynonymsLocal: '',
    countryCode: 'MX',
    currencyCode: 'MXN',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'MY',
    currencyCode: 'MYR',
    officialLanguageCode: 'ms'
  },
  {
    countryNameLocal: 'Mozambique',
    countrySynonymsLocal: '',
    countryCode: 'MZ',
    currencyCode: 'MZN',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Namibia',
    countrySynonymsLocal: '',
    countryCode: 'NA',
    currencyCode: 'NAD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nouvelle-Calédonie',
    countrySynonymsLocal: '',
    countryCode: 'NC',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Norfolk Island',
    countrySynonymsLocal: '',
    countryCode: 'NF',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nigeria',
    countrySynonymsLocal: '',
    countryCode: 'NG',
    currencyCode: 'NGN',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nicaragua',
    countrySynonymsLocal: '',
    countryCode: 'NI',
    currencyCode: 'NIO',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Norge, Noreg',
    countrySynonymsLocal: '',
    countryCode: 'NO',
    currencyCode: 'NOK',
    officialLanguageCode: 'nb'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'NP',
    currencyCode: 'NPR',
    officialLanguageCode: 'ne'
  },
  {
    countryNameLocal: 'Nauru',
    countrySynonymsLocal: '',
    countryCode: 'NR',
    currencyCode: 'AUD',
    officialLanguageCode: 'na'
  },
  {
    countryNameLocal: 'Niue',
    countrySynonymsLocal: '',
    countryCode: 'NU',
    currencyCode: 'NZD',
    officialLanguageCode: 'niu'
  },
  {
    countryNameLocal: 'New Zealand',
    countrySynonymsLocal: '',
    countryCode: 'NZ',
    currencyCode: 'NZD',
    officialLanguageCode: 'mi'
  },
  {
    countryNameLocal: 'سلطنة عُمان',
    countrySynonymsLocal: '',
    countryCode: 'OM',
    currencyCode: 'OMR',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Panama',
    countrySynonymsLocal: '',
    countryCode: 'PA',
    currencyCode: 'PAB',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Perú',
    countrySynonymsLocal: '',
    countryCode: 'PE',
    currencyCode: 'PEN',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Polynésie française',
    countrySynonymsLocal: '',
    countryCode: 'PF',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Papua New Guinea',
    countrySynonymsLocal: '',
    countryCode: 'PG',
    currencyCode: 'PGK',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'پاکستان',
    countrySynonymsLocal: '',
    countryCode: 'PK',
    currencyCode: 'PKR',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Polska',
    countrySynonymsLocal: '',
    countryCode: 'PL',
    currencyCode: 'PLN',
    officialLanguageCode: 'pl'
  },
  {
    countryNameLocal: 'Saint-Pierre-et-Miquelon',
    countrySynonymsLocal: '',
    countryCode: 'PM',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Pitcairn',
    countrySynonymsLocal: '',
    countryCode: 'PN',
    currencyCode: 'NZD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Puerto Rico',
    countrySynonymsLocal: '',
    countryCode: 'PR',
    currencyCode: 'USD',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Palestinian Territory',
    countrySynonymsLocal: '',
    countryCode: 'PS',
    currencyCode: '',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Portugal',
    countrySynonymsLocal: '',
    countryCode: 'PT',
    currencyCode: 'EUR',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Palau',
    countrySynonymsLocal: '',
    countryCode: 'PW',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Paraguay',
    countrySynonymsLocal: '',
    countryCode: 'PY',
    currencyCode: 'PYG',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'قطر',
    countrySynonymsLocal: '',
    countryCode: 'QA',
    currencyCode: 'QAR',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'La Réunion',
    countrySynonymsLocal: '',
    countryCode: 'RE',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'România',
    countrySynonymsLocal: '',
    countryCode: 'RO',
    currencyCode: 'RON',
    officialLanguageCode: 'ro'
  },
  {
    countryNameLocal: 'Србија',
    countrySynonymsLocal: '',
    countryCode: 'RS',
    currencyCode: 'RSD',
    officialLanguageCode: 'sr'
  },
  {
    countryNameLocal: 'Россия',
    countrySynonymsLocal: '',
    countryCode: 'RU',
    currencyCode: 'RUB',
    officialLanguageCode: 'ru'
  },
  {
    countryNameLocal: 'Rwanda',
    countrySynonymsLocal: '',
    countryCode: 'RW',
    currencyCode: 'RWF',
    officialLanguageCode: 'rw'
  },
  {
    countryNameLocal: 'السعودية',
    countrySynonymsLocal: '',
    countryCode: 'SA',
    currencyCode: 'SAR',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Solomon Islands',
    countrySynonymsLocal: '',
    countryCode: 'SB',
    currencyCode: 'SBD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Seychelles',
    countrySynonymsLocal: '',
    countryCode: 'SC',
    currencyCode: 'SCR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Sverige',
    countrySynonymsLocal: '',
    countryCode: 'SE',
    currencyCode: 'SEK',
    officialLanguageCode: 'sv'
  },
  {
    countryNameLocal: 'Singapore',
    countrySynonymsLocal: '',
    countryCode: 'SG',
    currencyCode: 'SGD',
    officialLanguageCode: 'zh-hans'
  },
  {
    countryNameLocal: 'Saint Helena',
    countrySynonymsLocal: '',
    countryCode: 'SH',
    currencyCode: 'SHP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Slovenija',
    countrySynonymsLocal: '',
    countryCode: 'SI',
    currencyCode: 'EUR',
    officialLanguageCode: 'sl'
  },
  {
    countryNameLocal: 'Svalbard and Jan Mayen',
    countrySynonymsLocal: '',
    countryCode: 'SJ',
    currencyCode: 'NOK',
    officialLanguageCode: 'no'
  },
  {
    countryNameLocal: 'Slovensko',
    countrySynonymsLocal: '',
    countryCode: 'SK',
    currencyCode: 'EUR',
    officialLanguageCode: 'sk'
  },
  {
    countryNameLocal: 'Sierra Leone',
    countrySynonymsLocal: '',
    countryCode: 'SL',
    currencyCode: 'SLL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Repubblica di San Marino',
    countrySynonymsLocal: '',
    countryCode: 'SM',
    currencyCode: 'EUR',
    officialLanguageCode: 'it'
  },
  {
    countryNameLocal: 'Sénégal',
    countrySynonymsLocal: '',
    countryCode: 'SN',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Somalia, الصومال',
    countrySynonymsLocal: '',
    countryCode: 'SO',
    currencyCode: 'SOS',
    officialLanguageCode: 'so'
  },
  {
    countryNameLocal: 'Suriname',
    countrySynonymsLocal: '',
    countryCode: 'SR',
    currencyCode: 'SRD',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'South Sudan',
    countrySynonymsLocal: '',
    countryCode: 'SS',
    currencyCode: 'SSP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'São Tomé e Príncipe',
    countrySynonymsLocal: '',
    countryCode: 'ST',
    currencyCode: 'STN',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'El Salvador',
    countrySynonymsLocal: '',
    countryCode: 'SV',
    currencyCode: 'SVC',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'Sint Maarten',
    countrySynonymsLocal: '',
    countryCode: 'SX',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'سوريا, Sūriyya',
    countrySynonymsLocal: '',
    countryCode: 'SY',
    currencyCode: 'SYP',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Tchad, تشاد',
    countrySynonymsLocal: '',
    countryCode: 'TD',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Togo',
    countrySynonymsLocal: '',
    countryCode: 'TG',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'ประเทศไทย',
    countrySynonymsLocal: '',
    countryCode: 'TH',
    currencyCode: 'THB',
    officialLanguageCode: 'th'
  },
  {
    countryNameLocal: ',',
    countrySynonymsLocal: '',
    countryCode: 'TJ',
    currencyCode: 'TJS',
    officialLanguageCode: 'tg'
  },
  {
    countryNameLocal: 'Tokelau',
    countrySynonymsLocal: '',
    countryCode: 'TK',
    currencyCode: 'NZD',
    officialLanguageCode: 'tkl'
  },
  {
    countryNameLocal: "Timor-Leste, Timor Lorosa'e",
    countrySynonymsLocal: '',
    countryCode: 'TL',
    currencyCode: 'USD',
    officialLanguageCode: 'pt'
  },
  {
    countryNameLocal: 'Türkmenistan',
    countrySynonymsLocal: '',
    countryCode: 'TM',
    currencyCode: 'TMT',
    officialLanguageCode: 'tk'
  },
  {
    countryNameLocal: 'تونس, Tunisie',
    countrySynonymsLocal: '',
    countryCode: 'TN',
    currencyCode: 'TND',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Tonga',
    countrySynonymsLocal: '',
    countryCode: 'TO',
    currencyCode: 'TOP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Türkiye',
    countrySynonymsLocal: '',
    countryCode: 'TR',
    currencyCode: 'TRY',
    officialLanguageCode: 'tr'
  },
  {
    countryNameLocal: 'Trinidad and Tobago',
    countrySynonymsLocal: '',
    countryCode: 'TT',
    currencyCode: 'TTD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Tuvalu',
    countrySynonymsLocal: '',
    countryCode: 'TV',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Tanzania',
    countrySynonymsLocal: '',
    countryCode: 'TZ',
    currencyCode: 'TZS',
    officialLanguageCode: 'sw'
  },
  {
    countryNameLocal: 'Україна',
    countrySynonymsLocal: '',
    countryCode: 'UA',
    currencyCode: 'UAH',
    officialLanguageCode: 'uk'
  },
  {
    countryNameLocal: 'Uganda',
    countrySynonymsLocal: '',
    countryCode: 'UG',
    currencyCode: 'UGX',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'United States of America',
    countrySynonymsLocal: 'USA Amerika America',
    countryCode: 'US',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Uruguay',
    countrySynonymsLocal: '',
    countryCode: 'UY',
    currencyCode: 'UYU',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'UZ',
    currencyCode: 'UZS',
    officialLanguageCode: 'uz'
  },
  {
    countryNameLocal: 'Saint Vincent and the Grenadines',
    countrySynonymsLocal: '',
    countryCode: 'VC',
    currencyCode: 'XCD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Venezuela',
    countrySynonymsLocal: '',
    countryCode: 'VE',
    currencyCode: 'VES',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'British Virgin Islands',
    countrySynonymsLocal: '',
    countryCode: 'VG',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'United States Virgin Islands',
    countrySynonymsLocal: '',
    countryCode: 'VI',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Việt Nam',
    countrySynonymsLocal: '',
    countryCode: 'VN',
    currencyCode: 'VND',
    officialLanguageCode: 'vi'
  },
  {
    countryNameLocal: 'Vanuatu',
    countrySynonymsLocal: '',
    countryCode: 'VU',
    currencyCode: 'VUV',
    officialLanguageCode: 'bi'
  },
  {
    countryNameLocal: 'Wallis-et-Futuna',
    countrySynonymsLocal: '',
    countryCode: 'WF',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Samoa',
    countrySynonymsLocal: '',
    countryCode: 'WS',
    currencyCode: 'WST',
    officialLanguageCode: 'sm'
  },
  {
    countryNameLocal: 'اليَمَن',
    countrySynonymsLocal: '',
    countryCode: 'YE',
    currencyCode: 'YER',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Mayotte',
    countrySynonymsLocal: '',
    countryCode: 'YT',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'South Africa',
    countrySynonymsLocal: '',
    countryCode: 'ZA',
    currencyCode: 'ZAR',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Zambia',
    countrySynonymsLocal: '',
    countryCode: 'ZM',
    currencyCode: 'ZMW',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Zimbabwe',
    countrySynonymsLocal: '',
    countryCode: 'ZW',
    currencyCode: 'ZWL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Swaziland',
    countrySynonymsLocal: '',
    countryCode: 'SZ',
    currencyCode: 'SZL',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Македонија',
    countrySynonymsLocal: '',
    countryCode: 'MK',
    currencyCode: 'MKD',
    officialLanguageCode: 'mk'
  },
  {
    countryNameLocal: 'Philippines',
    countrySynonymsLocal: '',
    countryCode: 'PH',
    currencyCode: 'PHP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Nederland',
    countrySynonymsLocal: '',
    countryCode: 'NL',
    currencyCode: 'EUR',
    officialLanguageCode: 'nl'
  },
  {
    countryNameLocal: 'دولة الإمارات العربيّة المتّحدة',
    countrySynonymsLocal: '',
    countryCode: 'AE',
    currencyCode: 'AED',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'Moldova, Молдавия',
    countrySynonymsLocal: '',
    countryCode: 'MD',
    currencyCode: 'MDL',
    officialLanguageCode: 'ro'
  },
  {
    countryNameLocal: 'The Gambia',
    countrySynonymsLocal: '',
    countryCode: 'GM',
    currencyCode: 'GMD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'República Dominicana',
    countrySynonymsLocal: '',
    countryCode: 'DO',
    currencyCode: 'DOP',
    officialLanguageCode: 'es'
  },
  {
    countryNameLocal: 'السودان',
    countrySynonymsLocal: '',
    countryCode: 'SD',
    currencyCode: 'SDG',
    officialLanguageCode: 'ar'
  },
  {
    countryNameLocal: 'ປະຊາຊົນລາວ',
    countrySynonymsLocal: '',
    countryCode: 'LA',
    currencyCode: 'LAK',
    officialLanguageCode: 'lo'
  },
  {
    countryNameLocal: 'Taiwan',
    countrySynonymsLocal: '',
    countryCode: 'TW',
    currencyCode: 'TWD',
    officialLanguageCode: 'zh-hant'
  },
  {
    countryNameLocal: 'République du Congo',
    countrySynonymsLocal: '',
    countryCode: 'CG',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Česká republika',
    countrySynonymsLocal: '',
    countryCode: 'CZ',
    currencyCode: 'CZK',
    officialLanguageCode: 'cs'
  },
  {
    countryNameLocal: 'Great Britain',
    countrySynonymsLocal: 'UK England GB',
    countryCode: 'GB',
    currencyCode: 'GBP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Niger',
    countrySynonymsLocal: '',
    countryCode: 'NE',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Democratic Republic of the Congo',
    countrySynonymsLocal: '',
    countryCode: 'CD',
    currencyCode: 'CDF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Commonwealth of The Bahamas',
    countrySynonymsLocal: '',
    countryCode: 'BS',
    currencyCode: 'BSD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Pulu Kokos (Keeling)',
    countrySynonymsLocal: '',
    countryCode: 'CC',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'République centrafricaine',
    countrySynonymsLocal: '',
    countryCode: 'CF',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: "Kūki 'Āirani",
    countrySynonymsLocal: '',
    countryCode: 'CK',
    currencyCode: 'NZD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Falkland Islands',
    countrySynonymsLocal: '',
    countryCode: 'FK',
    currencyCode: 'FKP',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Færøerne',
    countrySynonymsLocal: '',
    countryCode: 'FO',
    currencyCode: 'DKK',
    officialLanguageCode: 'da'
  },
  {
    countryNameLocal: 'Territory of Heard Island and McDonald Islands',
    countrySynonymsLocal: '',
    countryCode: 'HM',
    currencyCode: 'AUD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'British Indian Ocean Territory',
    countrySynonymsLocal: '',
    countryCode: 'IO',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Umoja wa Komori',
    countrySynonymsLocal: '',
    countryCode: 'KM',
    currencyCode: 'KMF',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'Cayman Islands',
    countrySynonymsLocal: '',
    countryCode: 'KY',
    currencyCode: 'KYD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Aolepān Aorōkin Ṃajeḷ',
    countrySynonymsLocal: '',
    countryCode: 'MH',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Sankattan Siha Na Islas Mariånas',
    countrySynonymsLocal: '',
    countryCode: 'MP',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Turks and Caicos Islands',
    countrySynonymsLocal: '',
    countryCode: 'TC',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Terres australes et antarctiques françaises',
    countrySynonymsLocal: '',
    countryCode: 'TF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr'
  },
  {
    countryNameLocal: 'United States Minor Outlying Islands',
    countrySynonymsLocal: '',
    countryCode: 'UM',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Sancta Sedes',
    countrySynonymsLocal: '',
    countryCode: 'VA',
    currencyCode: 'EUR',
    officialLanguageCode: 'la'
  },
  {
    countryNameLocal: 'Republika e Kosovës',
    countrySynonymsLocal: '',
    countryCode: 'XK',
    currencyCode: 'EUR',
    officialLanguageCode: 'sq'
  },
  {
    countryNameLocal: 'Nederlandse Antillen',
    countrySynonymsLocal: '',
    countryCode: 'AN',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl'
  }
] as const;

/**
 * @deprecated usw explicit countries import instead.
 */
export default countries;
